// src/components/Header/index.jsx
import React from 'react';
import { Layout, Menu, Typography, Button, Space } from 'antd';
import { HomeOutlined, AppstoreOutlined, UserOutlined, EditOutlined, LogoutOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const { Header } = Layout;
const { Title } = Typography;

const AppHeader = ({ loggedInUser, onLogout }) => {
  const location = useLocation();

  return (
    <Header style={{ backgroundColor: '#fff', padding: '0 50px', borderBottom: '1px solid #e8e8e8', height: '64px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        {/* 左侧：博客标题 */}
        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
          <Link to="/">我的博客</Link>
        </div>

        {/* 右侧：导航菜单 */}
        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          {/* 导航链接 */}
          <Menu 
            mode="horizontal" 
            selectedKeys={[location.pathname]} 
            style={{ margin: 0 }}
          >
            <Menu.Item key="/" icon={<HomeOutlined />}>
              <Link to="/">首页</Link>
            </Menu.Item>
            <Menu.Item key="/archive" icon={<AppstoreOutlined />}>
              <Link to="/archive">归档</Link>
            </Menu.Item>
            <Menu.Item key="/about" icon={<UserOutlined />}>
              <Link to="/about">关于</Link>
            </Menu.Item>
            {loggedInUser && ( // 仅当用户已登录时显示写文章按钮
              <Menu.Item key="/write" icon={<EditOutlined />}>
                <Link to="/write">写文章</Link>
              </Menu.Item>
            )}
          </Menu>

          {/* 用户操作区 */}
          {loggedInUser ? (
            <Space size="middle">
              <Typography.Text strong>{loggedInUser.name}</Typography.Text>
              <Button type="link" onClick={onLogout} icon={<LogoutOutlined />}>
                退出
              </Button>
            </Space>
          ) : (
            <Space size="middle">
              <Button type="link" href="/auth">登录</Button>
              <Button type="link" href="/auth">注册</Button>
            </Space>
          )}
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;